/*=========================================================================================
  File Name: gettes.js
  Description: Restaurant Getters
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/
import moment from 'moment'

export default { 
    canOrderNow: (state) => {

      let currentTime = moment(state.currentLocalTime, 'HH:mm:ss');

      let index = state.restaurants.findIndex(i => i.restaurantId === state.currentRestaurantId);

      if (index < 0) {
        return - 1;
      }

      let canFrom = moment(state.restaurants[index].canOrderFrom, 'HH:mm:ss');

      let cannotFrom = moment(state.restaurants[index].cannotOrderFrom, 'HH:mm:ss');

      let from = moment(state.restaurants[index].fromTime, 'HH:mm:ss');
      
      if (currentTime.isBetween(from ,cannotFrom)) {
        console.log('In opening hours')
        return 1; 
      }
      else {
        if (currentTime.isBetween(canFrom, from)) {
          console.log('Earlier than opening hours but can order')
          return 0;
        }
        else {
          console.log('Cannot place an order')
          return -1; //cannot order
        }
      }
    },
    isNearlyClosing: (state) => {
      let toTime = moment(state.restaurants[state.currentRestaurantId.toTime], 'HH:mm:ss').hours();
      let currentTime = moment(state.currentLocalTime, 'HH:mm:ss').hours();

      if(toTime - currentTime <= 1) {
        return true; 
      }
      return false;
    },
    restaurantMap : (state) => (restaurantId) => {
      let index = state.restaurantMaps.findIndex(i => i.id === restaurantId);

      if (index < 0) {
        return {
          id : '',
          image : '',
          map: ''
        }
      }

      return state.restaurantMaps[index];

    },
    currentRestaurantOpeningTime : (state) => {
      let index = state.restaurants.findIndex(i => i.restaurantId === state.currentRestaurantId);

      if (index < 0) {
        return null;
      }
      let openingTime = {
        canOrderFrom : state.restaurants[index].canOrderFrom,
        cannotOrderFrom : state.restaurants[index].cannotOrderFrom,
        fromTime : state.restaurants[index].fromTime,
        toTime : state.restaurants[index].toTime,
      }
      //console.log('openting time from getters')
      //console.log(openingTime)
      return openingTime;

    },

    restaurantName : (state) => (currentId) => {
      let index = state.restaurants.findIndex(i => i.restaurantId === currentId);

      if (index < 0) {
        return null;
      }

      return state.restaurants[index].restaurantName;
    },

    currentRestaurant : (state) => {
      let index = state.restaurants.findIndex(i => {return i.restaurantId === state.currentRestaurantId});
      if (index < 0)  {
        return null;
      }
      return state.restaurants[index]
    }


}